export const HOME_PAGE_PATH = "/";
export const LOGIN_PAGE_PATH = "/login";
export const ADMIN_LOGIN_PAGE_PATH = "/adminlogin";
export const TWENTY_MINUTES_TIME_IN_MILLISECONDS = "59940000";
export const API_TOKEN_NAME = "api_token";
export const API_TOKEN_EXPIRY_NAME = "api_token_expiry";
export const API_AUTH_USERNAME = "OSL";
export const API_AUTH_PASSWORD = "osl@2022";
export const USER_ROLE = "USER_ROLE";
export const USER_ID = "USER_ID";
export const USER_EMAIL = "USER_EMAIL";
export const LOGIN_PHONE_NUMBER = "login_phone_number";
export const SEARCH_SELECTED_DOC_ID = "search_selected_doc_id";
export const SCHEDULE_DATE = "schedule_date";
export const APPOINTMENT_ID = "apointment_id";
export const DOCTOR_NAME = "doctor_name";
export const DOCTOR_FEES = "doctor_fees";
export const PATIENT_NAME = "patient_name";
export const PATIENT_DATE_OF_BIRTH = "patient_date_of_birth";
export const SCHEDULE_TIME = "schedule_time";
export const SEARCH_SELECTED_DOC_NAME = "search_selected_doc_name";
export const DOCTOR_PROFILE_AVABILITY = "doctor_profile_avability";
export const USER_LOCAL_ID = "user_local_id";

let dynUrl;
let imgUrl;
let Pageurl;
let siteUrl;
let profileUrl;
let apiImageUrl;

let host_name = window.location.hostname;
let erp_url = "https://uhlapi.etherstaging.xyz";

// if (host_name === 'localhost') {
// 	imgUrl = process.env.REACT_APP_LOCAL_URL + ':8000/';
// 	apiImageUrl="https://uhlbackend.etherstaging.xyz/";
// 	dynUrl = process.env.REACT_APP_LOCAL_URL + '/demoreactapibackend/api';
// 	Pageurl = process.env.REACT_APP_LOCAL_URL + ':3000/pages/';
// 	siteUrl = process.env.REACT_APP_LOCAL_URL;
// 	profileUrl = process.env.REACT_APP_LOCAL_URL + '/unitedhospitalapi';
// }
// if (host_name === 'etherstaging.com') {
// 	imgUrl = process.env.REACT_APP_STAGING_URL + '/unitedhospitalapi/public/';
// 	dynUrl = process.env.REACT_APP_STAGING_URL + '/unitedhospitalapi/api';
// 	Pageurl = process.env.REACT_APP_STAGING_URL + '/pages/';
// 	siteUrl = process.env.REACT_APP_STAGING_URL;
// 	profileUrl = process.env.REACT_APP_STAGING_URL + '/unitedhospitalapi';
// }

if (host_name === "localhost") {
  imgUrl = process.env.REACT_APP_LOCAL_BACKEND_URL + "/public/";
  dynUrl = process.env.REACT_APP_LOCAL_BACKEND_URL + "/api";
  Pageurl = process.env.REACT_APP_LOCAL_PRODUCTION_URL + "/pages/";
  siteUrl = process.env.REACT_APP_LOCAL_PRODUCTION_URL;
  profileUrl = process.env.REACT_APP_LOCAL_BACKEND_URL;
}

if (host_name === "etherstaging.com") {
  imgUrl = process.env.REACT_APP_ETHER_BACKEND_URL + "/public/";
  dynUrl = process.env.REACT_APP_ETHER_BACKEND_URL + "/api";
  Pageurl = process.env.REACT_APP_ETHER_PRODUCTION_URL + "/pages/";
  siteUrl = process.env.REACT_APP_ETHER_PRODUCTION_URL;
  profileUrl = process.env.REACT_APP_ETHER_BACKEND_URL;
}

if (host_name === "beta.uhlbd.com") {
  imgUrl = process.env.REACT_APP_BETA_BACKEND_URL + "/public/";
  dynUrl = process.env.REACT_APP_BETA_BACKEND_URL + "/api";
  Pageurl = process.env.REACT_APP_BETA_PRODUCTION_URL + "/pages/";
  siteUrl = process.env.REACT_APP_BETA_PRODUCTION_URL;
  profileUrl = process.env.REACT_APP_BETA_BACKEND_URL;
}

if (host_name === "uhlbd.com") {
  imgUrl = process.env.REACT_APP_LIVE_BACKEND_URL + "/public/";
  dynUrl = process.env.REACT_APP_LIVE_BACKEND_URL + "/api";
  Pageurl = process.env.REACT_APP_LIVE_PRODUCTION_URL + "/pages/";
  siteUrl = process.env.REACT_APP_LIVE_PRODUCTION_URL;
  profileUrl = process.env.REACT_APP_LIVE_BACKEND_URL;
}

export const IMAGE_URL = imgUrl;
export const BASE_URL = dynUrl;
export const WEBSITEPAGE_URL = Pageurl;
export const SITE_URL = siteUrl;
export const PROFILE_URL = profileUrl;
export const APIIMAGE_URL = apiImageUrl;
export const ERPUrl = erp_url;



// WEBPACK FOOTER //
// ./src/constants.js